/* eslint-disable prettier/prettier */
import request from '@/utils/request';

const apiPrefix = '/vesionbook-building-core/api/v1';
const apiVisitor = '/vesionbook-building-visitor/api/v1';
import axios from 'axios';

const api = {
  getInfo: payload => request.get(`${apiPrefix}/wechat/company/setting/${payload}`),
  visitorApply: payload => request.post(`${apiPrefix}/visitor/h5/apply`, payload),
  sendSMS: payload => request.post(`${apiPrefix}/sms/send`, payload),
  uploadPicture: payload => request.post(`${apiPrefix}/common/image/upload`, payload),
  uploadFile: payload => request.post(`${apiPrefix}/common/file/upload`, payload),
  login: payload => request.post(`${apiPrefix}/visitor/h5/login`, payload),
  register: payload => request.post(`${apiPrefix}/visitor/h5/register`, payload),
  visitorList: payload => request.post(`${apiPrefix}/visitor/h5/list`, payload),
  review: payload => request.post(`${apiPrefix}/visitor/h5/approval`, payload),
  devices: payload => request.post(`${apiPrefix}/visitor/h5/selectDeviceList`, payload),
  codeInfo: payload => request.post(`${apiPrefix}/visitor/h5/getVrcode`, payload),
  visitorUserApply: payload => request.post(`${apiPrefix}/visitor/h5/invite`, payload),
  deleteVisitor: payload => request.post(`${apiPrefix}/visitor/h5/delete`, payload),
  hasQrcode: payload => request.post(`${apiPrefix}/visitor/h5/hasQrcode`, payload),
  authPersonName: payload => request.get(`${apiPrefix}/visitor/h5/telephone/query`, payload),

  getMeetingRoomList: payload => request.get(`${apiPrefix}/conference/book/ListAllMeetingRoom`, payload),
  getMeetingRoomByTime: payload => request.get(`${apiPrefix}/conference/book/selectMeetingRoom`, payload),
  getMeetingRoomInfo: payload => request.get(`${apiPrefix}/conference/book/queryMeetingRoom/${payload.id}`, payload),
  getMeetingRoomMyList: payload => request.get(`${apiPrefix}/conference/my/query`, payload),
  getMeetingRoomMyBook: payload => request.get(`${apiPrefix}/conference/my/listMyBook/${payload.id}`, payload),
  getMeetingRoomInfoMy: payload => request.get(`${apiPrefix}/conference/my/detail`, payload),
  getMeetingRoomInfoInvite: payload => request.get(`${apiPrefix}/conference/my/listInvited`, payload),
  getMeetingRoomInfoCheck: payload => request.get(`${apiPrefix}/conference/my/queryCheckRecord/${payload.id}`, payload),
  deleteMeetingRoomInfo: payload => request.post(`${apiPrefix}/conference/book/delete/${payload.id}`, payload),
  addMeetingRoomInfo: payload => request.post(`${apiPrefix}/conference/book/create`, payload),
  updateMeetingRoomInfo: payload => request.post(`${apiPrefix}/conference/book/update/${payload.id}`, payload),
  getMeetingPersonList: payload => request.get(`${apiPrefix}/conference/book/selectPerson`, payload),
  getMeetingAllList: payload => request.get(`${apiPrefix}/conference/book/listAllConference`, payload),
  getTokenByTicketServices: payload => request.post(`${apiPrefix}/conference/book/login`, payload),

  verifyUser: payload => request.post(`${apiPrefix}/faceCollect/login`, payload),
  collectPhoto: payload => request.post(`${apiPrefix}/faceCollect`, payload),
  getPublicResource: payload => axios.get(`${window.location.origin}/${payload}`),

  getPublicMonthList: payload => axios.get(`${window.location.origin}/${payload}`),
  getPublicMeetingAllList: payload => axios.get(`${window.location.origin}/${payload}`),

  getVisitorReason: payload => request.get(`${apiVisitor}/visitor/sh/h5/select/reason`, payload),
  getVisitorArea: payload => request.get(`${apiVisitor}/visitor/sh/h5/select/area`, payload),
  getVisitorBuilding: payload => request.get(`${apiVisitor}/visitor/sh/h5/select/building`, payload),
  getVisitorType: payload => request.post(`${apiVisitor}/visitor/sh/h5/select/current/visitorType`, payload),

  postVisitorApply: payload => request.post(`${apiVisitor}/visitor/sh/h5/apply`, payload),
  getVisitorCarInfoList: payload => request.post(`${apiVisitor}/visitor/sh/h5/park/select`, payload),
  getVisitorCarMonthList: payload => request.get(`${apiVisitor}/visitor/sh/selectMonth`, payload),

  getVisitorRecordList: payload => request.get(`${apiVisitor}/visitor/sh/h5/select/${payload.id}`, payload),
  putVisitorApply: payload => {
    const { id, visitorInfos } = payload;
    return request.post(`${apiVisitor}/visitor/sh/h5/update/${id}`, { visitorInfos: visitorInfos });
  },
  getRecordSearchList: payload => request.get(`${apiVisitor}/visitor/sh/h5/result`, payload),
  uploadOaFile: payload => request.post(`${apiVisitor}/visitor/sh/oaFile/upload?name=${payload.name}`, payload.formData),

};

export default api;
